const VISITOR_TOKEN_KEY = "mvk_visitor_token";
const ADMIN_TOKEN_KEY = "mvk_admin_token";

function get(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function set(key: string, token: string): void {
  localStorage.setItem(key, token);
}

function clear(key: string): void {
  localStorage.removeItem(key);
}

export const visitorAuthStorage = {
  getToken: () => get(VISITOR_TOKEN_KEY),
  setToken: (token: string) => set(VISITOR_TOKEN_KEY, token),
  clearToken: () => clear(VISITOR_TOKEN_KEY),
  isAuthenticated: () => Boolean(get(VISITOR_TOKEN_KEY)),
};

export const adminAuthStorage = {
  getToken: () => get(ADMIN_TOKEN_KEY),
  setToken: (token: string) => set(ADMIN_TOKEN_KEY, token),
  clearToken: () => clear(ADMIN_TOKEN_KEY),
  isAuthenticated: () => Boolean(get(ADMIN_TOKEN_KEY)),
};

/** @deprecated use visitorAuthStorage or adminAuthStorage */
export const authStorage = visitorAuthStorage;
